module.exports = __webpack_public_path__ + "img/Onboarding3.2d16865e.png";